import React from 'react'
import {
  Button,
  Checkbox,
  FormControlLabel,
  Typography
} from '@material-ui/core'

import { GoalGroupSection } from './types'
import { useStyles } from './styles'

interface GoalSelectionListProps {
  sections: GoalGroupSection[]
  selectedGoalIds: Set<string>
  onToggleAll: () => void
  onToggleGoal: (goalId: string) => void
  onToggleSection: (section: GoalGroupSection) => void
}

export const GoalSelectionList = ({
  sections,
  selectedGoalIds,
  onToggleAll,
  onToggleGoal,
  onToggleSection
}: GoalSelectionListProps) => {
  const classes = useStyles()
  const goals = sections.flatMap(section => section.goals)
  const allSelected = goals.length > 0 && goals.every(goal => selectedGoalIds.has(goal._id))

  return (
    <>
      <div className={classes.listHeader}>
        <div>
          <Typography className={classes.listTitle}>Lojas com meta</Typography>
          <Typography
            className={classes.selectionCount}
            variant='caption'
            aria-live='polite'
          >
            {selectedGoalIds.size} de {goals.length} lojas selecionadas
          </Typography>
        </div>
        <Button
          className={classes.utilityButton}
          color='primary'
          onClick={onToggleAll}
          size='small'
        >
          {allSelected ? 'Limpar seleção' : 'Selecionar todas'}
        </Button>
      </div>

      <div className={classes.groupsList}>
        {sections.map(section => {
          const selectedCount = section.goals.filter(goal => selectedGoalIds.has(goal._id)).length
          const sectionSelected = selectedCount === section.goals.length
          const sectionPartiallySelected = selectedCount > 0 && !sectionSelected

          return (
            <section
              className={classes.groupSection}
              key={section.id}
              aria-labelledby={`bulk-goal-group-${section.id}`}
            >
              <div className={classes.groupHeader}>
                <FormControlLabel
                  className={classes.groupControl}
                  control={
                    <Checkbox
                      checked={sectionSelected}
                      color='primary'
                      indeterminate={sectionPartiallySelected}
                      inputProps={{
                        'aria-checked': sectionPartiallySelected ? 'mixed' : sectionSelected
                      }}
                      onChange={() => onToggleSection(section)}
                    />
                  }
                  label={
                    <Typography
                      className={classes.groupName}
                      id={`bulk-goal-group-${section.id}`}
                      variant='body2'
                    >
                      {section.name}
                    </Typography>
                  }
                />
                <Typography className={classes.groupCount}>
                  {selectedCount} de {section.goals.length}
                </Typography>
              </div>
              <div className={classes.storeGrid}>
                {section.goals.map(goal => (
                  <FormControlLabel
                    className={classes.storeControl}
                    key={goal._id}
                    control={
                      <Checkbox
                        checked={selectedGoalIds.has(goal._id)}
                        color='primary'
                        inputProps={{ 'data-goal-id': goal._id } as React.InputHTMLAttributes<HTMLInputElement>}
                        onChange={() => onToggleGoal(goal._id)}
                      />
                    }
                    label={
                      <Typography className={classes.storeName}>
                        {goal.store.name}
                      </Typography>
                    }
                  />
                ))}
              </div>
            </section>
          )
        })}
      </div>
    </>
  )
}
